import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { DataService } from './data.service';

const INEST_REDIRECT = '/i-nest/attendance/self';

const checkStartup = (url: string): boolean => {
  const dataService = inject(DataService);
  const router = inject(Router);

  if (dataService.empTypeValue === 's' && !url.startsWith('/i-nest')) {
    router.navigate([INEST_REDIRECT]);
    return false;
  }
  return true;
};

export const startupGuard: CanActivateFn = (_route, state) =>
  checkStartup(state.url);

export const startupChildGuard: CanActivateChildFn = (_route, state) =>
  checkStartup(state.url);
